import CustomCursor from "@/components/animatedComponents/CustomCursor";
import LightSpots from "@/components/animatedComponents/LightSpots";
import Footer from "@/components/Footer";
import Navbar from "@/components/Navbar";
import WhatWeDo from "@/components/WhatWeDo";
import { useGsapFadeIn } from "@/hooks/useGsapAnimation";

const About = () => {
  const headingRef = useGsapFadeIn<HTMLDivElement>();

  return (
    <div className="min-h-screen bg-[#f5f5f5] relative overflow-x-hidden">
      {/* Custom Cursor */}
      <CustomCursor />

      {/* Light Spots Background */}
      <LightSpots />

      {/* Main Layout */}
      <div className="relative z-10">
        <Navbar initialColor={"[#0d1821]"} />
        <main>
          <div id="smooth-wrapper">
            <div id="smooth-content">
              {/* Header */}
              <div
                ref={headingRef}
                className="px-6 lg:px-0 max-w-[1370px] mx-auto pt-36 lg:pt-48"
              >
                <h3 className="font-[600] text-3xl sm:text-4xl md:text-6xl lg:text-6xl mb-6 font-orbitron leading-tight lg:text-center">
                  <span className="text-foreground">About </span>
                  <br className="block lg:hidden" />
                  <span className="text-primary">Us</span>
                </h3>
                <p className="md:text-left text-md md:text-xl leading-relaxed font-poppins text-md text-muted-foreground text-justify">
                  We’re a team of creative thinkers, strategists, and digital
                  experts who are passionate about helping brands grow and
                  succeed in the digital world. With a blend of creativity,
                  strategy, and technology, we craft solutions that drive
                  results and make a lasting impact.
                </p>
              </div>
              <WhatWeDo />
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default About;
